import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import routes from './routes'

Vue.use(VueRouter)

/**
 * The Router instance containing all the routes for the application.
 */
const router = new VueRouter({
    base: '/',
    mode: 'history',
    linkExactActiveClass: 'active',
    routes
    /* routes: routes.map(route => ({
        name: route.name,
        path: route.path,
        component: route.component,
        beforeEnter: route.isPublic ? null : guardRoute
    })) */
});

router.beforeEach((to, from, next) => {    
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.       
        if (!store.getters['users/isLoggedIn']) {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    }

    next() // make sure to always call next()!

})

/**
 * Guard the route from unauthorized users.
 *
 * @param  {Route}    to   The route we want to access.
 * @param  {Route}    from The route from which we are coming from.
 * @param  {Function} next Callback for passing a route to be called next.
 * @return {void}
 */
function guardRoute(to, from, next) {
    //const loggedIn = !!TokenService.getToken();
    if (!store.getters['users/isLoggedIn']) {
        next({
            path: '/login',
            query: {
                redirect: to.fullPath // Store the full path to redirect the user to after login
            }
        });
    }

    next();
}

export default router
